<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-ideologias
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-fingerprint mr-2'></i>Geográficos</h4>"
          v-else
        ></table-ideologias>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableIdeologias from "./TableIdeologias";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "facebookPages",
  components: {
    TableIdeologias,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "reach_estimate", label: "Alcance potencial", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getIdeologias();
  },
  methods: {
    getIdeologias() {
      var ideologias = store.getters.getIdeologias;
      if (ideologias.length == 0) {
        this.isLoading = true;
        store.dispatch("getIdeologias").then(() => {
          ideologias = store.getters.getIdeologias;
          shuffleArray([ideologias]);
          this.isLoading = false;
          this.items = ideologias;
          this.itemsArray = ideologias;
        });
      } else {
        shuffleArray([ideologias]);
        this.items = ideologias;
        this.itemsArray = ideologias;
      }
    }
  }
};
</script>
